// extracted by mini-css-extract-plugin
export default {"lastEditInfoContainer":"MarkdownLastEditedBy-module__lastEditInfoContainer--Zq7l_","mutedEditorLink":"MarkdownLastEditedBy-module__mutedEditorLink--QXVvq"};